import React from 'react'
import Fixed from './Fixed'
//import Catagories from './Catagories'
//import Footer from './Footer'
import Services from './Services'
import Footer1 from './Footer1'

const ShopByCatagories = () => {
  return (
    <div>
        <Fixed />
        <div className="pt-10">
        <Services />
        </div>
        <Footer1 />
    </div>
  )
}

export default ShopByCatagories;